<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading tabla -->
      <div
        class="d-flex justify-content-center w-100 mt-4"
        v-if="loadingServiciosPuertos"
      >
        <loading />
      </div>

      <!-- dataTable y botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>
        <!-- Botones -->
        <div class="w-100" style="position: relative; z-index: 1">
          <div class="d-flex" style="position: absolute">
            <ui-select
              placeholder="Seleccionar puerto"
              :options="puertos"
              hasSearch
              v-model="portModel"
              :keys="{ value: 'id', label: 'name' }"
            />
            <Button
              :size="15"
              color="#2da44e"
              colorText="#ffffff"
              tooltip="Agregar Puertos"
              icon="fas fa-plus"
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              traslate
              @click.native="addPort()"
            />
          </div>
        </div>
        <!-- Data Table -->
        <data-table
          v-if="acciones.length > 0"
          :headers="headers"
          :data="dataTableAux"
          :acciones="acciones"
          :max="8"
          paginacion
          buscar
          :formulario="true"
          idtabla="servicios_puertos"
          :seleccionar="obtenerFilaSeleccionada"
        />
        <not-found-table
          v-else
          class="justify-content-center w-100 pt-5"
          :text="'No se encontraron registros de puertos en este servicio'"
        /> 
        <button class="btn btn-outline-warning btn-sm h-50 mt-3 btn-update float-right" @click="actualizarPuertos()" id="buttonRef">
            Actualizar
        </button>
      </div>
    </div>
    <actualizar-servicios-puertos-modal
      :dataAux="dataServiciosPuertosActualizar"
      :nombreServicio="nombreServicio" 
    />
  </div>
</template>

<script>
// Vue
import Vue from "vue";

import { mapState, mapActions } from "vuex";

// Not Found
import NotFoundTable from "../../../components/common/NotFoundTable";

import {
  getServiciosPuertos,
  deleteServiciosPuertos,
saveServiciosPuertos,
} from "../../../constants/lineas";

import DataTable from "../../../components/common/DataTable";
import Loading from "../../../components/common/loading";
import ActualizarServiciosPuertosModal from "../../../components/modals/lineas/servicios/ActualizarServiciosPuertosModal";

// Toast
import VueToastify from "vue-toastify";
import Button from "../../../components/common/Button";

Vue.use(VueToastify);

export default {
  props: ["id","nombreServicio"],
  data() {
    return {
      headers: ["Puerto", "TT Reefer", "TT Dry", "Corte Documental Anticipado", "Acciones"],
      acciones: [],
      dataServiciosPuertosActualizar: [],
      data: [],
      dataTableAux: [],
      idAux: this.id,
      portModel:{}
    };
  },

  components: {
    DataTable,
    ActualizarServiciosPuertosModal,
    Loading,
    Button,
    NotFoundTable
  },

  computed: {
    ...mapState(["loading", "loadingServiciosPuertos","puertos"]),
    ...mapState("lineas", [
      "dataDatatableServiciosPuertos",
      "dataDatatableServiciosPuertosFiltrada",
    ]),
  },

  methods: {
    // Acciones de Vuex
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoadingTable",
      "ActionSetLoadingServiciosPuertos",
    ]),
    ...mapActions("lineas", [
      "actionSetVisibleModalEditarServicioPuerto",
      "actionSetDataServiciosPuertos",
    ]),

    // Obteneción de Depositos desde la BD
    async getDataServiciosPuertos() {
      
      this.ActionSetLoadingServiciosPuertos(true);

      const { data } = await getServiciosPuertos(this.idAux);
      
      this.dataTableAux = data.data_table.map( dt => ({
        data: dt.data ,
        data_complementaria: dt.data_complementaria,
        accion: "ACTUALIZAR",
        type: [
          { key: 0, type: "text" },
          { key: 1, type: "textbox" },
          { key: 2, type: "textbox" },
          { key: 3, type: "checkboxset" },
        ]
      }));

      //this.actionSetDataServiciosPuertos( data.data_table );
      this.generarBotonesAcciones();
    },
    async actualizarPuertos() {
      let valid = true ;

      if( this.dataTableAux.length === 0 ) return this.$vToastify.error(
        "Debe agregar puertos",
        "Error"
      );
      this.dataTableAux.forEach( dt => {
        if( dt.data[1] < 1 ) valid = false ;
        if( dt.data[2] < 1 ) valid = false ;
      });
      
      if( !valid ) return this.$vToastify.error(
        "No deben quedar campos en 0 o menor a 0",
        "Error"
      );

      this.$vToastify.loader("Actualizando Servicio...");

      this.estadoButton("Actualizando...");

      const form = {
        route_name : this.nombreServicio ,
        route_id : this.idAux,
        routes_ports : this.dataTableAux.map( dt => ({
          accion: dt.accion ,
          port_id : parseInt( dt.data_complementaria.id_puerto ),
          id : parseInt( dt.data_complementaria.id ),
          reefer_transit_time: parseInt( dt.data[1] ) ,
          dry_transit_time: parseInt( dt.data[2] ),
          has_early_cutoff: dt.data[3],
        }))
      } ;

      const { error } = await saveServiciosPuertos( form ) ;

      this.estadoButton("Actualizar", false);
      this.$vToastify.stopLoader();

      if( !error ){
        this.getDataServiciosPuertos() ;
        return this.$vToastify.success(
          "Servicio actualizado correctamente",
          "¡Realizado!"
        );
      }
      this.$vToastify.error(
        "Error al actualizar servicio, intente más tarde",
        "Error"
      );
    },
    async addPort(){
      if( this.portModel.name == "" ) return ;
      if (this.portModel.name == "" || this.portModel.name == undefined) return;

      this.dataTableAux.push({
        data: [ this.portModel.name , 0,0,false ] ,
        data_complementaria: {
          id_puerto: this.portModel.id ,
          id_servicio: 0 ,
          id: 0
        },
        accion: "AGREGAR",
        type: [
          { key: 0, type: "text" },
          { key: 1, type: "textbox" },
          { key: 2, type: "textbox" },
          { key: 3, type: "checkboxset" },
        ]
      });
      this.generarBotonesAcciones() ;

      this.portModel = {} ;
    },
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async generarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataTableAux.map((index) => {
        me.acciones.push([{
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
      me.ActionSetLoadingTable(false);
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async obtenerFilaSeleccionada(fila) {
      let id_puerto = fila.id.data_complementaria.id_puerto;
      let nombre_puerto = fila.id.data[0];
      if (fila.accion == "Editar") {

        this.dataServiciosPuertosActualizar = fila.id;
        this.actionSetVisibleModalEditarServicioPuerto(true);

      } else if (fila.accion == "Eliminar") {

        const response = await this.$vToastify.prompt({
          body: `¿Desea eliminar el Puerto '${nombre_puerto}'?`,
          answers: { Sí: true, No: false },
        });
          
        if( !response ) return ;

        this.dataTableAux = this.dataTableAux.filter( dt => dt.data_complementaria.id_puerto != id_puerto );
        this.generarBotonesAcciones() ;
        
      }
    },

    async eliminarServicioPuerto(id_puerto, id_servicio) {
      let sql = await deleteServiciosPuertos({ id_puerto, id_servicio });

      if (!sql.error) {
        this.$vToastify.success(
          "Puerto eliminado correctamente",
          "¡Realizado!"
        );

        // Consulta nuevamente a la API para obtener la nueva data
        let dataServiciosPuertosDB = await getServiciosPuertos(this.idAux);

        // Actualizar los datos del dataTable
        this.actionSetDataServiciosPuertos(
          dataServiciosPuertosDB.data.data_table
        );

        this.dataTableAux = dataServiciosPuertosDB.data.data_table;
        this.generarBotonesAcciones();
      } else {
        console.log("Error");
      }
    },
    // Función para actualizar url en state
  },
  created() {
    this.generarBotonesAcciones();
    this.actualizarURL();
  },
  watch: {
    id: function (_new) {
      let me = this;
      if (_new) {
        this.dataTableAux = [];
        me.idAux = _new;
        me.getDataServiciosPuertos();
      }
    },
    dataDatatableServiciosPuertos: function (_new) {
      let me = this;
      if (_new) {
        me.data = _new;
        me.data.fila = _new;
        me.generarBotonesAcciones();
      }
    },

    dataDatatableServiciosPuertosFiltrada: function (_new) {
      this.dataTableAux = _new;
      this.generarBotonesAcciones();
    },
  },
};
</script>

<style scoped>

.textbox_normal {
  padding: 7px 5px;  
}
</style>
